module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/145-ukraine-380e378f99a2e5fd5c34162e9186525c.svg";